module.exports = __webpack_public_path__ + "img/after6.7d408558.png";